import { computed, toRef } from "vue";

import { propsDefinition } from "@/lib/composables/componentComposable";

type UseSubtextScoped = {
  subtext?: string;
};

type UseSubtextProps = UseSubtextScoped & {
  subtextId?: string;
};

const scoped = propsDefinition({
  subtext: { type: String, required: false },
}) satisfies Record<keyof UseSubtextScoped, unknown>;

const props = propsDefinition({
  ...scoped,
  subtextId: { type: String, required: false },
}) satisfies Record<keyof UseSubtextProps, unknown>;

function use(props: UseSubtextProps) {
  return {
    subtext: toRef(() => props.subtext),
    id: toRef(() => props.subtextId),
  };
}

function vIf(props: Pick<UseSubtextProps, "subtext">) {
  return computed(() => !!props.subtext);
}

export type { UseSubtextProps, UseSubtextScoped };
export { props, scoped, use, vIf };
